export const LzHelperAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'messenger', internalType: 'address', type: 'address' },
      { name: 'amountsInNative', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'dstEids', internalType: 'uint16[]', type: 'uint16[]' },
    ],
    name: 'convertToDstNative',
    outputs: [{ name: 'results', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
] as const
